import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadToursHighlightsSection/OffRoadToursHighlightsSection.styles';

const OffRoadToursHighlightsSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Container maxWidth="xl">
        {/* Section Title */}
        <Skeleton variant="text" width={300} height={40} sx={{ mb: 3 }} />
        
        {/* Section Description */}
        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="60%" height={24} sx={{ mb: 8 }} />

        {/* Highlights Grid */}
        <Grid container spacing={4}>
          {[...Array(3)].map((_, item) => (
            <Grid item lg={4} md={12} sm={12} key={item}>
              <Box>
                {/* Icon Skeleton */}
                <Skeleton 
                  variant="rectangular" 
                  width={48} 
                  height={48} 
                  sx={{ mb: 2 }} 
                />
                
                {/* Highlight Title */}
                <Skeleton variant="text" width="80%" height={32} sx={{ mb: 2 }} />
                
                {/* List Items */}
                <Box className="OTHSList">
                  {[...Array(4)].map((_, itemIndex) => (
                    <Box 
                      key={itemIndex} 
                      sx={{ mb: 1 }}
                    >
                      <Skeleton variant="text" width="95%" height={20} />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { OffRoadToursHighlightsSectionSkeleton };